import React, {Component, Fragment} from "react";
import {Link} from 'react-router-dom';
/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
import { updateForm } from "../../../../store/actions/FormAction";
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../../partials/AlertDialogSlide";

import LoanSummary from "./LoanSummary";

class FastTrackCopy extends Component {
  constructor(props){
    super(props);

    this.fastTrack = this.fastTrack.bind(this);
    this.recommendForApproval = this.recommendForApproval.bind(this);
    this.newApplication = this.newApplication.bind(this);
    this.paidOff = this.paidOff.bind(this);

    this.toggleBankVerification = this.toggleBankVerification.bind(this);
    this.toggleReferences = this.toggleReferences.bind(this);
  }

  fastTrack(e){
    e.preventDefault();
    this.props.updateForm("status", "Fast Tracked");
  }

  recommendForApproval(e){
    e.preventDefault();
    this.props.updateForm("status", "Recommended For Approval");
  }

  paidOff(e){
    e.preventDefault();
    this.props.updateForm("status", "Paid Off");
  }

  newApplication(e){
    e.preventDefault();
    this.props.updateForm("status", "Originated");
    this.props.updateForm("originatedmsg", true);
  }

  toggleBankVerification(e){
    let bankverification = document.getElementById("bankverification");

    let titleareanode = e.target;
    if (e.target.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode;
    } else if (e.target.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode.parentNode;
    }

    if (bankverification.classList.contains('noheight')){
      bankverification.classList.remove("noheight");
      bankverification.classList.add("newheight");
      titleareanode.classList.add("pref-open");
    } else {
      bankverification.classList.add("noheight");
      bankverification.classList.remove("newheight");
      titleareanode.classList.remove("pref-open");
    }
  }

  toggleReferences(e){
    let references = document.getElementById("references");
    let titleareanode = e.target;
    if (e.target.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode;
    } else if (e.target.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode.parentNode;
    }
    if (references.classList.contains('noheight')){
      references.classList.remove("noheight");
      references.classList.add("newheight");
      titleareanode.classList.add("pref-open");
    } else {
      references.classList.add("noheight");
      references.classList.remove("newheight");
      titleareanode.classList.remove("pref-open");
    }
  }

  toggleMakeAPayment(e){
    let makeapayment = document.getElementById("makeapayment");

    let titleareanode = e.target;
    if (e.target.parentNode.classList.contains('greenaction')){
      titleareanode = e.target.parentNode;
    } else if (e.target.parentNode.parentNode.classList.contains('greenaction')){
      titleareanode = e.target.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.parentNode.classList.contains('greenaction')){
      titleareanode = e.target.parentNode.parentNode.parentNode;
    }

    if (makeapayment.classList.contains('noheight')){
      makeapayment.classList.remove("noheight");
      makeapayment.classList.add("newheight");
      titleareanode.classList.add("pref-open");
    } else {
      makeapayment.classList.add("noheight");
      makeapayment.classList.remove("newheight");
      titleareanode.classList.remove("pref-open");
    }
  }
  toggleRequestALoan(e){
    let requestaloan = document.getElementById("requestaloan");

    let titleareanode = e.target;
    if (e.target.parentNode.classList.contains('greenaction')){
      titleareanode = e.target.parentNode;
    } else if (e.target.parentNode.parentNode.classList.contains('greenaction')){
      titleareanode = e.target.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.parentNode.classList.contains('greenaction')){
      titleareanode = e.target.parentNode.parentNode.parentNode;
    }

    if (requestaloan.classList.contains('noheight')){
      requestaloan.classList.remove("noheight");
      requestaloan.classList.add("newheight");
      titleareanode.classList.add("pref-open");
    } else {
      requestaloan.classList.add("noheight");
      requestaloan.classList.remove("newheight");
      titleareanode.classList.remove("pref-open");
    }
  }


  render() {
    if (this.props.status === "Fast Tracked"){
      return (
        <div className="text-center">
          <p className="narrowtext">
            Speak to a Customer Care agent to review your terms and you could have your money within 1 business day.
          </p>
          <a className="btn last-step padtop" onClick={this.recommendForApproval}>Call us now</a>
          <div className="padTop30"></div>
        </div>
      )
    } else if (this.props.status === "Pending"){
      return (
        <Fragment>
          <p className="narrowtext text-center">
            Fast Track your approval by reviewing and completing the action item(s) below or call us at <a href="tel:18662551668" onClick={this.fastTrack}>1-866-255-1668.</a>
          </p>

          <p className="buttontitle padtop">Action Items</p>

          <div className="changedrop">
            <div className="preferences" onClick={this.toggleBankVerification}>
              <svg className="actioncaret" width="20px" viewBox="0 0 20 20">
                <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#6E7677">
                  <circle className="Oval-3" strokeWidth="0.5" cx="9" cy="9" r="9"></circle>
                  <polyline className="downarrow" strokeWidth="1.0546875" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                </g>
              </svg>
              <span>Bank Verification</span>
            </div>
            <div id="bankverification" className="expandedpref noheight ">
              <p className="text-center padtop">Verify your bank account online or call us at <a href="tel:18662551668">1-866-255-1668</a> to verify your banking information over the phone. </p>

              <a className="btn last-step padtop" onClick={this.newApplication}>Verify My Account</a>

              <p className="text-center padtop30"><AlertDialogSlide linkText="What's this?" tip="bankverification"/></p>

              <p>&nbsp;</p>
            </div>
          </div>

          <div className="changedrop">

            <div className="preferences" onClick={this.toggleReferences}>
              <svg className="actioncaret" width="20px" viewBox="0 0 20 20">
                <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#6E7677">
                  <circle className="Oval-3" strokeWidth="0.5" cx="9" cy="9" r="9"></circle>
                  <polyline className="downarrow" strokeWidth="1.0546875" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                </g>
              </svg>
              <span>References</span>
            </div>
            <div id="references" className="expandedpref noheight">
              <p className="text-center padtop">Your references must be over the age of 18 and not living in the same household as you. Your references will not be contacted to approve your application.</p>
              <hr />
              <div className="detailsbox">
                <div id="ref1box">
                  <h5>Name</h5>
                  <p>{this.props.ref1fn} {this.props.ref1ln}</p>
                  <h5 className="padtop">Phone</h5>
                  <p>{this.props.ref1phn}</p>
                  <h5 className="padtop">Relationship</h5>
                  <p>{this.props.ref1rel}</p>
                  <svg className="editpen" onClick={this.editRef1Info} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                    <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                  </svg>
                </div>
                <div id="ref1field" className="form-group hidden">
                  <label htmlFor="phn">
                    <div className="errortip hidden" id="phntip">
                        Please provide a valid phone number.
                    </div>
                    <h5>Name</h5>
                    <input type="text" name="fn1" id="fn1" className="form-control" placeholder="First Name" value={this.props.ref1fn} onChange={this.handleFn1Change} onBlur={this.handleFn1Blur} onKeyUp={this.handleFn1KeyUp}/>
                    <input type="text" name="ln1" id="ln1" className="form-control" placeholder="Last Name" value={this.props.ref1ln} onChange={this.handleLn1Change} onBlur={this.handleLn1Blur} onKeyUp={this.handleLn1KeyUp}/>
                    <h5 className="padtop">Phone</h5>
                    <input type="text" name="phn1" id="phn1" className="form-control" placeholder="eg: 512-123-4567" value={this.props.ref1phn} onChange={this.handlePhone1Change} onBlur={this.handlePhone1Blur} onKeyUp={this.handlePhone1KeyUp} maxLength="12"/>
                    <h5 className="padtop">Relationship</h5>
                    <input type="text" name="rel1" id="rel1" className="form-control" placeholder="eg: Father" value={this.props.ref1rel} onChange={this.handleRel1Change} onBlur={this.handleRel1Blur} onKeyUp={this.handleRel1KeyUp}/>
                  </label>
                </div>
              </div>
              <hr />
              <div className="detailsbox">
                <div id="ref2box">
                  <h5>Name</h5>
                  <p>{this.props.ref2fn} {this.props.ref2ln}</p>
                  <h5 className="padtop">Phone</h5>
                  <p>{this.props.ref2phn}</p>
                  <h5 className="padtop">Relationship</h5>
                  <p>{this.props.ref2rel}</p>
                  <svg className="editpen" onClick={this.editRef2Info} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                    <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                  </svg>
                </div>
                <div id="ref1field" className="form-group hidden">
                  <label htmlFor="phn">
                    <div className="errortip hidden" id="phntip">
                        Please provide a valid phone number.
                    </div>
                    <h5>Name</h5>
                    <input type="text" name="fn2" id="fn2" className="form-control" placeholder="First Name" value={this.props.ref2fn} onChange={this.handleFn2Change} onBlur={this.handleFn2Blur} onKeyUp={this.handleFn2KeyUp}/>
                    <input type="text" name="ln2" id="ln2" className="form-control" placeholder="Last Name" value={this.props.ref2ln} onChange={this.handleLn2Change} onBlur={this.handleLn2Blur} onKeyUp={this.handleLn2KeyUp}/>
                    <h5>Phone</h5>
                    <input type="text" name="phn2" id="phn2" className="form-control" placeholder="eg: 522-223-4567" value={this.props.ref2phn} onChange={this.handlePhone2Change} onBlur={this.handlePhone2Blur} onKeyUp={this.handlePhone2KeyUp} maxLength="12"/>
                    <h5>Relationship</h5>
                    <input type="text" name="rel2" id="rel2" className="form-control" placeholder="eg: Father" value={this.props.ref2rel} onChange={this.handleRel2Change} onBlur={this.handleRel2Blur} onKeyUp={this.handleRel2KeyUp}/>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )
    } else if (this.props.status === "Recommended For Approval"){
      return (
        <Fragment>
          <p className="narrowtext text-center padtop">
            Your application looks good so far -  we’re just double checking it.<br />
            If approved, the funds will be deposited into your bank account the next business day.
          </p>

          <LoanSummary />
        </Fragment>
      );
    } else if (this.props.status === "Withdrawn" && this.props.eligible){
      return (
        <Fragment>
          <p className="narrowtext text-center padtop">
            Your application has been withdrawn.<br/>
            To process another application, apply online using the button below or call Customer Care at <a href="tel:18662551668" onClick={this.paidOff}>1-866-255-1668</a>.
          </p>
          <Link to="/preapproved" className="btn last-step padtop">Apply Now</Link>
        </Fragment>
      );
    } else if (this.props.status === "Withdrawn" && !this.props.eligible){
      return (
        <Fragment>
          <p className="narrowtext text-center padtop">
            Your application has been withdrawn.<br/>
            Based on your information, we are unable to offer you a loan product at this time.<br />
            <br />
            However, you may be able to find a loan product suitable for you from another company* by clicking “Continue” below:.
          </p>
          <Link to="/" className="btn last-step padtop">Continue</Link>
          <p className="legaltext">
            Please note that by clicking “Continue”, you are navigating away from the MoneyKey website to the website of an unaffiliated third party.<br />
            <br />
            MoneyKey does not promote or endorse the sponsored listings, and does not assume responsibility or liability for any actions taken by you in relation to any such sponsored listings.
          </p>
        </Fragment>
      );
    } else if (this.props.status === "Closed"){
      return (
        <Fragment>
          <p className="narrowtext text-center padtop">
            Your account with us has been closed.<br/>
            Based on your status, we are unable to offer you a loan product at this time.
          </p>
          <p className="narrowtext text-center">
            However, you may be able to find a loan product suitable for you from another company* by clicking “Continue” below:
          </p>
          <a className="btn last-step padtop" onClick={this.newApplication}>Continue</a>
          <p className="legaltext">
            Please note that by clicking “Continue”, you are navigating away from the MoneyKey website to the website of an unaffiliated third party.<br />
            <br />
            MoneyKey does not promote or endorse the sponsored listings, and does not assume responsibility or liability for any actions taken by you in relation to any such sponsored listings.
          </p>
        </Fragment>
      );
    } else if (this.props.status === "Paid Off"){
      return (
        <Fragment>
          <p className="narrowtext text-center padtop30">
            Awesome news! You have paid off your loan and are now eligible for a new loan.
          </p>
          <Link to="reloan" className="btn last-step padtop">Request A Loan</Link>
          <div className="padtop30"></div>
        </Fragment>
      );
    } else if (this.props.status === "Originated" || this.props.status === "Default" || this.props.status === "Delinquent"){
      return (
        <Fragment>
          <LoanSummary />

          <div className="changedrop">
            <div className="actionitem greenaction padtop30" onClick={this.toggleMakeAPayment}>
              <svg className="actioncaret" width="20px" viewBox="0 0 20 20">
                <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#ffffff">
                  <circle className="Oval-3" strokeWidth="1" cx="9" cy="9" r="9"></circle>
                  <polyline className="downarrow" strokeWidth="1.5" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                </g>
              </svg>
              <span style={{marginTop:'3px',color:'white'}}>Make A Payment</span>
            </div>
            <div id="makeapayment" className="expandedpref noheight">
              <p className="text-center padtop padbottom">You can make an additional payment or pay off your loan in full any time by calling <a href="tel:18662551668">1-866-255-1668</a>.</p>
              <p style={{ lineHeight:'5px' }}>&nbsp;</p>
            </div>
          </div>

        </Fragment>
      );
    } else if (this.props.status === "Default SIF/PIF"){
      return (
        <Fragment>
          <p className="narrowtext text-center padtop">
            Awesome news! You have paid off your balance and may be eligible for a new loan.
          </p>

          <div className="changedrop">
            <div className="actionitem greenaction padtop30" onClick={this.toggleRequestALoan}>
              <svg className="actioncaret" width="20px" viewBox="0 0 20 20">
                <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#6E7677">
                  <circle className="Oval-3" strokeWidth="1" cx="9" cy="9" r="9"></circle>
                  <polyline className="downarrow" strokeWidth="1.5" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                </g>
              </svg>
              <span style={{marginTop:'3px'}}>Request a Loan</span>
            </div>
            <div id="requestaloan" className="expandedpref noheight">
              <p className="text-center padtop">Contact Customer Care to request a loan and you could have your funds in as soon as 1 business day.</p>
              <a className="btn last-step padtop30 padbottom" href="tel:18662551668">Call Us Now</a>
              <p style={{ lineHeight:'5px' }}>&nbsp;</p>
            </div>
          </div>
        </Fragment>
      );
    } else if (this.props.status === "Pending Paid Off"){
      return (
        <Fragment>
          <LoanSummary />

          <div className="changedrop">
            <div className="actionitem greenaction padtop30" onClick={this.toggleRequestALoan}>
              <svg className="actioncaret" width="20px" viewBox="0 0 20 20">
                <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#6E7677">
                  <circle className="Oval-3" strokeWidth="1" cx="9" cy="9" r="9"></circle>
                  <polyline className="downarrow" strokeWidth="1.5" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                </g>
              </svg>
              <span style={{marginTop:'3px'}}>Request a Loan</span>
            </div>
            <div id="requestaloan" className="expandedpref noheight">
              <p className="text-center padtop">Contact Customer Care to request a loan and you could have your funds in as soon as 1 business day.</p>
              <a className="btn last-step padtop30 padbottom" href="tel:18662551668">Call Us Now</a>
              <p style={{ lineHeight:'5px' }}>&nbsp;</p>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return "";
    }
  }
}

const mapStateToProps = (state) => ({
    ref1fn: state.FormReducer.ref1fn,
    ref1ln: state.FormReducer.ref1ln,
    ref1phn: state.FormReducer.ref1phn,
    ref1rel: state.FormReducer.ref1rel,
    ref2fn: state.FormReducer.ref2fn,
    ref2ln: state.FormReducer.ref2ln,
    ref2phn: state.FormReducer.ref2phn,
    ref2rel: state.FormReducer.ref2rel,
    eligible: state.FormReducer.eligible,
    status: state.FormReducer.status
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(FastTrackCopy);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/partials/FastTrackCopy.js